import { deprecatedComponent } from '../core/deprecated-component.js';
import { createComponent } from '../core/create-component.js';
/**
 * @deprecated use StandardHero or StandardBanner instead
 */

var EmbeddedTextHeroLink = deprecatedComponent({
  displayName: 'EmbeddedTextHeroLink',
  description: 'EmbeddedTextHeroLink is Deprecated. Migrate to Standard Hero or Standard Banner',
  root: createComponent({
    displayName: 'EmbeddedTextHeroLink',
    root: 'a',
    propConfig: {
      classNames: ['swan-embedded-text-hero-link']
    }
  })
});
export { EmbeddedTextHeroLink };